enum GapFillStatusEnum {
  none = "none",
  gapFilled = "gapFilled",
  researching = "researching",
  contractingGapClosure = "contractingGapClosure",
  contractingExceptionEligible = "contractingExceptionEligible",
  exceptionRequired = "exceptionRequired",
  rppoWaiverRequired = "rppoWaiverRequired",
  availableEntitiesWillNotContract = "availableEntitiesWillNotContract"
}

export default GapFillStatusEnum;
